import { Component, OnInit, ViewChild } from '@angular/core';
import { Form } from '@angular/forms';
import { IonModal, ModalController } from '@ionic/angular';
import { Formule } from 'src/app/models/formule';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { UserService } from 'src/app/services/user.service';
import { FormuleFormComponent } from '../formule-form/formule-form.component';

@Component({
  selector: 'app-list-formule',
  templateUrl: './list-formule.component.html',
  styleUrls: ['./list-formule.component.scss'],
})
export class ListFormuleComponent implements OnInit {

  @ViewChild(IonModal) modal: IonModal;
  message: string;
  formules: Formule[];
  isEdit: boolean;
  formuleEdit: Formule;
  showListBtnBox: boolean = false
  popoverEvent: any;
  selectedFormule: Formule;
  popoverOpen = false;


  constructor(
    private coachService: UserService,
    private ApiProviderService: ApiProviderService,
    private modalCtrl: ModalController
  ) { }



  ngOnInit() {
    let coach = this.coachService.getUser();
    let coachId = coach.id;
    this.ApiProviderService.getFormulesByCoach(coachId).subscribe(
      (res: Formule[]) => {
        // Ajoutez la propriété showListBtnBox à chaque élément avec une valeur initiale de false
        this.formules = res.map(formule => ({ ...formule, showListBtnBox: false }));
      },
      (err) => {
        this.formules = [];
      },
    );
  }


  addNewFormule(formule: string) {
    let f: Formule = JSON.parse(formule)
    this.formules.push(f);
  }

  deleteFormule(formule: Formule) {

    this.ApiProviderService.deleteFormule(formule).subscribe(
      (res: any) => {
        let index = this.formules.findIndex(formule => formule.id == res)
        this.formules.splice(index, 1)
      },
      (err) => { this.message = "erreur lors de la suppression" },
    );
  }

  editFormuleEvent(formule: string) {
    let f: Formule = JSON.parse(formule)
    let index = this.formules.findIndex(formule => f.id == formule.id)
    this.formules[index] = f
      ;
  }

  //Modal 

  cancel() {
    this.modal.dismiss(null, 'cancel');

  }


  modalEdit(formule: Formule) {
    const title = "Modifier une formule";
    console.log("prout")
    this.getFormuleEdit(formule);
    this.openModal(title);
  }

  getFormuleEdit(formule: Formule) {
    this.formuleEdit = formule
  };


  async openModal(title: string) {
    const modal = await this.modalCtrl.create({
      component: FormuleFormComponent,
      componentProps: {
        foo: this.formuleEdit,
        title: title
      }
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      this.formules.push(data);
    }
    this.formuleEdit = null;
  }

  toggleListBtnBox(formule: any) {
    formule.showListBtnBox = !formule.showListBtnBox;
    this.formules.forEach(item => {
      if (item !== formule) {
        item.showListBtnBox = false;
      }
    });
  }

  //PopOver
  openPopover(ev: Event, formule: Formule) {
    console.log(formule)
    this.popoverEvent = ev;
    this.selectedFormule = formule;
    this.popoverOpen = true;

  }

}
